import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) { return { error }; }

  componentDidCatch(error, info) { console.error("Unhandled UI error:", error, info); }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="error-boundary">
        <div className="max-w-md w-full bg-white border border-slate-200 rounded-xl shadow-sm p-8 text-center">
          <div className="mx-auto h-12 w-12 rounded-full bg-red-50 flex items-center justify-center mb-4">
            <span className="text-red-500 text-2xl font-bold leading-none">!</span>
          </div>
          <h1 className="font-heading text-lg font-bold text-slate-900">Something went wrong</h1>
          <p className="text-sm text-slate-500 mt-2">An unexpected error occurred on this screen. Your data is safe — reload to continue working.</p>
          <p className="text-[11px] font-mono text-slate-400 mt-3 break-all">{String(this.state.error?.message || this.state.error)}</p>
          <button onClick={() => window.location.reload()}
            className="mt-5 h-10 px-6 rounded-md bg-[#f04935] text-white text-sm font-semibold hover:opacity-90 transition-opacity"
            data-testid="error-reload-btn">
            Reload app
          </button>
        </div>
      </div>
    );
  }
}
